export const environment = {
	production: false,
	appVersion: 'v0.0.1',
	isMockEnabled: false,
	api: 'https://loyalty-staging.spotside.com/api',
	project: 'loyaltycard',
	apiUrl: 'api',
	keycloak: {
		url: 'https://accounts.spotside.com',
		realm: 'Loyalty',
		clientId: 'loyalty-pwa',
	},
};
